/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import forge, {Middleware} from 'mappersmith'
import type ShipmentsClientClientInterface from './ShipmentsClientClientInterface'

type FactoryOptions = {
  host?: string
  middleware?: Middleware[]
}

const ShipmentsClientClientFactory = ({
  host,
  middleware,
}: FactoryOptions = {}): ShipmentsClientClientInterface =>
  forge({
    clientId: 'argus:apollo',
    host: host || '',
    middlewares: [...(middleware || [])],
    resources: {
      Shipments: {
        fetch: {
          path: '/api/v1/services/shipments',
          method: 'get',
        },
        create: {
          path: '/api/v1/services/shipments',
          method: 'post',
        },
      },
      ShipmentDetails: {
        byId: {
          path: '/api/v1/services/shipments/{externalShipmentId}/details',
          method: 'get',
        },
      },
      UserSettings: {
        fetch: {
          path: '/api/v1/users/settings/shipments',
          method: 'get',
        },
        update: {
          path: '/api/v1/users/settings/shipments',
          method: 'patch',
        },
      },
    },
  })

export default ShipmentsClientClientFactory
